// Supported parameters: https://skro.eu/docs/postback/parameters-in-postback-urls
export const postbackParameterGroups = [
    {title: 'Conversion parameters', description: 'Map the tokens supported by your affiliate network.', parameters: [
        {name: 'clickId', label: 'Click ID', description: 'Required Skro click ID token.', required: true, placeholder: '{clickid}'},
        {name: 'payout', label: 'Payout', description: 'Conversion revenue amount.', placeholder: '{payout}'},
        {name: 'status', label: 'Status', description: 'Network conversion status.', placeholder: '{status}'},
        {name: 'transactionId', label: 'Transaction ID', description: 'Unique conversion or Google Ads order ID.', placeholder: '{transaction_id}'},
        {name: 'createdAtUTC', label: 'Conversion created time (UTC)', description: 'Conversion creation time in UTC. Format: 2026-09-27 15:04:05', placeholder: '2006-01-02 15:04:05'},
        {name: 'payoutCurrencyCode', label: 'Payout currency', description: 'Currency code, such as USD.', placeholder: 'USD'},
        {name: 'protectionToken', label: 'Protection token', description: 'Requires protection enabled for this network.', placeholder: 'Your secret token'},
        {name: 'ce', label: 'Custom Conversion', description: 'Requires a matching Custom Conversion.', placeholder: 'purchase'}
    ]},
    {title: 'Additional parameters', description: 'Include extra information from your network.', parameters:
        Array.from({length: 5}, (_, index) => ({name: `p${index + 1}`, label: `Parameter ${index + 1}`, placeholder: '{network_token}'}))},
    {title: 'Conversion API parameters', description: 'Requires the corresponding ad account and Conversion API integration.', parameters: [
        {name: 'firstName', label: 'First name', description: 'Meta', placeholder: '{first_name}'},
        {name: 'lastName', label: 'Last name', description: 'Meta', placeholder: '{last_name}'},
        {name: 'email', label: 'Email', description: 'Meta', placeholder: '{email}'},
        {name: 'phone', label: 'Phone', description: 'Meta', placeholder: '{phone}'},
        {name: 'zip', label: 'ZIP / postal code', description: 'Meta: lowercase, no spaces or dashes.', placeholder: '{zip}'},
        {name: 'fbLoginId', label: 'Facebook login ID', description: 'Meta', placeholder: '{fb_login_id}'},
        {name: 'fbp', label: 'Facebook browser ID', description: 'Meta', placeholder: '{fbp}'},
        {name: 'sourceDomain', label: 'Source domain', description: 'Meta / TikTok', placeholder: 'example.com'},
        {name: 'eventId', label: 'Event ID', description: 'Meta / TikTok deduplication', placeholder: '{event_id}'},
        {name: 'userConsent', label: 'User consent', description: 'Google Ads: true grants consent.', placeholder: 'true'}
    ]}
];
export const postbackParameters = postbackParameterGroups.flatMap(group => group.parameters);

export function createPostbackBuilderState(initialUrl) {
    const [endpoint, ...queryParts] = (initialUrl || '').split('?');
    const query = queryParts.join('?');
    const existing = {};
    const decode = value => {
        try { return decodeURIComponent(value.replace(/\+/g, ' ')); } catch { return value; }
    };
    query.split('&').forEach(part => {
        const separator = part.indexOf('=');
        if (separator >= 0) existing[decode(part.slice(0, separator))] = decode(part.slice(separator + 1));
    });
    const values = {};
    const enabled = {};
    postbackParameters.forEach(parameter => {
        const value = existing[parameter.name];
        values[parameter.name] = value && !['OPTIONAL', 'OPTINAL', 'REPLACE', 'REQUIRED'].includes(value) ? value : '';
        enabled[parameter.name] = !!parameter.required || !!values[parameter.name];
    });
    return {endpoint, values, enabled};
}

function encodePostbackValue(value) {
    // Leave network macros intact while encoding literal values and query separators.
    return value.split(/(\$?\{[^{}]+\}|\[[^[\]]+\]|#[^#]+#|%%[^%]+%%|%[A-Za-z_][\w.]*%|\$\([^)]+\))/g)
        .map((part, index) => index % 2 ? part : encodeURIComponent(part)).join('');
}

export function buildPostbackUrl(endpoint, values, enabled) {
    const query = postbackParameters.filter(parameter => enabled[parameter.name])
        .map(parameter => `${parameter.name}=${encodePostbackValue((values[parameter.name] || '').trim())}`).join('&');
    return `${endpoint.trim()}${query ? '?' + query : ''}`;
}

export function isValidPostbackEndpoint(endpoint) {
    try {
        const url = new URL(endpoint.trim());
        return ['https:', 'http:'].includes(url.protocol) && !/[?#]/.test(endpoint.trim());
    } catch { return false; }
}
